import gql from 'graphql-tag';

export const SEARCH_INTEGRATION_PARTNERS = gql`
  query searchIntegrationPartners($input: SearchIntegrationPartnersInput) {
    searchIntegrationPartners(input: $input) {
      id
      name
      configurableRelationships {
        typeCode
        name
      }
      slug
      description
      hasApacIntegration
      hasMiddlewareRequirement
      imageUrl
      releaseNotes
      releaseNotesImageUrl
      releaseNotesStatus
      siteUrl
      status
      type
    }
  }
`;
